module.exports = __webpack_public_path__ + "static/media/schedule_white.31f16a8b.svg";